export default __webpack_public_path__ + "static/media/main.7b61ed09.png";